"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLocalDateTimeField = void 0;
const local_date_time_field_1 = require("../../../components/local-date-time-field/local-date-time-field");
const form_field_1 = require("./form-field");
exports.FormLocalDateTimeField = form_field_1.formFieldFactory(local_date_time_field_1.LocalDateTimeField);
//# sourceMappingURL=form-local-date-time-field.js.map